import { i18n } from '@lingui/core';
import { t, Trans } from '@lingui/macro';
import React, { useState } from 'react';
import { useLocation } from 'react-router';
import { changeEmail } from '../../util/APIUtils';
import { error, success } from '../../util/toast';
import AuthLayout from '../layout';
import ChangeEmailSuccess from './changeEmailSuccess';
import ChangeEmailFail from './changeEmailFail';

function useQuery() {
  const { search } = useLocation();

  return React.useMemo(() => new URLSearchParams(search), [search]);
}

export default function ChangeEmail() {
  let query = useQuery();
  const key = query.get('key');
  const [status, setStatus] = useState(null);
  const active = () => {
    changeEmail(key)
      .then((res) => {
        if (res.ok) {
          success(i18n._(t`Đổi email thành công`));
          setStatus(true);
          return;
        }
        setStatus(false);
      })
      .catch((err) => {
        error(
          err.message.includes('Failed to fetch')
            ? i18n._(t`Không có kết nối internet`)
            : (err && err.detail) ||
                i18n._(t`Oops, có lỗi xảy ra, vui lòng thử lại sau`),
        );
      });
  };

  return (
    <>
      {status !== null ? (
        status ? (
          <AuthLayout>
            <ChangeEmailSuccess />
          </AuthLayout>
        ) : (
          <AuthLayout>
            <ChangeEmailFail />
          </AuthLayout>
        )
      ) : (
        <AuthLayout>
          <div className="flex flex-col items-center w-full text-slate-600">
            <div className="w-auto font-bold text-3xl mb-[20px]">
              <Trans>Vui lòng nhấn vào đây để thay đổi email</Trans>
            </div>
            <div className='flex justify-center'>
              <button
                onClick={() => active()}
                className="px-5 py-2 text-white transition duration-300 rounded bg-luat_HN_primary hover:bg-luat_HN_primary_hover text-[20px]"
              >
                <Trans>Thay đổi email</Trans>
              </button>
            </div>
          </div>
        </AuthLayout>
      )}
    </>
  );
}
